import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {MonoTypeOperatorFunction, Observable, of, switchMap} from 'rxjs';
import {tap} from 'rxjs/operators';
import {Dashboard} from './dashboard';
import {DashboardStorageService} from './dashboard-storage.service';
import {UserDataResolverService} from './user-data-resolver.service';

const RESET_DASHBOARD_QUERY_PARAM = 'reset-dashboard';

@Injectable()
export class DashboardResolverService {

    constructor(
        private dashboardStorageService: DashboardStorageService,
        private userDataResolverService: UserDataResolverService,
        private router: Router
    ) {}

    public resolve(route: ActivatedRouteSnapshot): Observable<Dashboard> {
        return this.userDataResolverService.resolve().pipe(
            this.handleResetDashboardParam(route),
            switchMap(() => this.dashboardStorageService.load())
        );
    }

    public resetDashboard(route: ActivatedRouteSnapshot): Observable<any> {
        return this.dashboardStorageService.resetDashboard().pipe(
            tap(() => {
                const urlParts = route.url.map(urlSegment => urlSegment.path);

                // Reset the route's query parameters.
                this.router.navigate([...urlParts]);
            })
        );
    }

    private handleResetDashboardParam(route: ActivatedRouteSnapshot): MonoTypeOperatorFunction<unknown> {
        return switchMap(() =>
            route.queryParamMap.has(RESET_DASHBOARD_QUERY_PARAM)
                ? this.resetDashboard(route)
                : of(null)
        );
    }

}
